<script>
import {encodeUrlToOptionString, getAttrVal, getCornerPic, goToTest} from '@/utils/help.js'
import {Toast} from "vant";
import wx from "weixin-js-sdk";
import BigArmyWxDialog from "@/pages/wx/components/BigArmyWxDialog.vue";

const MICRO_SERVICE_VUE2_BASE = process.env.VUE_APP_MICRO_SERVICE_VUE2;

export default {
  name: "ABenefit",
  components: {BigArmyWxDialog},
  data(){
    return {
      showContactDialog:false,
      dataPage:[],
      userInfo:{},
      statusList: new Map([[0, '生成中'], [1, '生成中'], [2, '已生成'], [-2, '已删除'], [3, '未授权']]),
      payList:[
        {
          value: 2,
          label: '充值金',
        },
        {
          value: 1,
          label: '套餐',
        }
      ]
    }
  },
  props:{
    item:Object
  },

  async mounted() {
  },
  computed: {},
  methods:{
    getAttrVal,
    getCornerPic,
    clickStatusTip (v) {
      // console.log();
      // if (v.goodsId != 20) {
      //   this.show = true;
      //   return;
      // }

      if (v) {
        sessionStorage.setItem("goodsName", v.goodsName);
      }
      goToTest(v, this.$router, this.$route);
      this.showReportTitle = true;
    },
    toTest(){
      goToTest(v, this.$router, this.$route);
    },
    goDetection (v) {
      if (v.usableNum < 1) {
        Toast('可用次数为0，请先购买。');
        return;
      }

      if (v.spu=='service'){
        this.showContactDialog = true
        return;
      }





      const resolvedRouter = this.$router.resolve({
        name:'wx-startDetection',
        query: {
          goodInfo: JSON.stringify(v),
          skuId: v.skuId,
          goodsId: v.goodsId,
          channelUniqueId: sessionStorage.getItem("channelUniqueId"),
          code: this.$route.query.code,
        },
      });
      //console.log(resolvedRouter.href)


      const h5Url = encodeUrlToOptionString(resolvedRouter.href)
      const currentDomain = window.location.origin
      const fullH5Url = `${currentDomain}${h5Url}`
      //console.log(fullH5Url)

      wx.miniProgram.navigateTo({
        url: `/pages/WebViewer/WebViewer?url=${fullH5Url}`
      })



    },
  }
}
</script>

<template>
  <div>
    <div class="benefit-item" >
      <div class="goods-pic">
        <img class="pic" :src="item.showImageUrl" alt="" />
        <img class="version-logo"
             :src="getCornerPic(item.skuAttr)"
             alt="">
      </div>
      <div style="margin-left: 0.2rem;position: relative;min-height: 2rem">
        <div class="goods-name">{{ item.goodsName }}</div>
<!--        <div class="timeTwo">-->
<!--          结算方式：{{ payList.find(i => i.value === item.settlementMethod)?.label ?? '' }}-->
<!--        </div>-->
        <div class="goods-text">
          收费模式：{{ getAttrVal(item.skuAttr, 'chargeMode') }}
        </div>
        <div  class="goods-text" v-if="item.settlementMethod !== 2">有效期：{{ getAttrVal(item.skuAttr, 'validity') }}

        </div>
        <div class="goods-text available-count" v-if="item.spu=='service'">
          <span>次数：{{ item.usableNum }}</span>
        </div>
        <div class="goods-text available-count" v-else>
          <span>可用数：{{ item.usableNum }}</span>
        </div>
      </div>
      <div class="cost2 toTest" @click.stop="goDetection(item)">
        <p>立即使用</p>
      </div>
    </div>

    <BigArmyWxDialog v-model="showContactDialog" title="1 V 1 专属服务">
      <template #content>
        <div class="contact-dialog-content">
          <div class="features">
            <div class="feature">
              <div class="icon iconfont icon-icon_duigou02"></div>
              报告领取
            </div>
            <div class="feature">
              <div class="icon iconfont icon-icon_duigou02"></div>
              产品体验
            </div>
            <div class="feature">
              <div class="icon iconfont icon-icon_duigou02"></div>
              在线咨询
            </div>
            <div class="feature">
              <div class="icon iconfont icon-icon_duigou02"></div>
              服务预约
            </div>
          </div>
          <div class="qr-img-wrapper">
            <img
                   src="https://shuian-file.oss-cn-hangzhou.aliyuncs.com/wx/qr-customer-service%402.png"
                   show-menu-by-longpress
                   class="qr-img"/>
            <div class="qr-tip">长按扫码添加客服</div>
          </div>
        </div>
      </template>
    </BigArmyWxDialog>
  </div>
</template>

<style scoped lang="stylus">
.benefit-item {
  display: flex
  padding-bottom .3rem
  position relative;
  color: #606368;
  font-weight: 400;
  font-size: .24rem;

  .goods-name{
    font-weight bold
    font-size: .28rem;
    margin-bottom .12rem
    color #1d2129
  }
  .available-count{
    position absolute;
    bottom 0
  }
  .goods-text{
    margin-bottom .1rem
  }
  .available-count{
    margin-bottom 0
  }
  .pic{
    width: 2.2rem;
    height 2rem
    border-radius: 0.16rem;
    position absolute
    left: 0;
    top: 0;
    z-index: 1;

  }
  .goods-pic{
    position relative;
    width 2.2rem
    .version-logo{
      z-index 1
      position absolute
      right 0;
      top :0
      width .8rem
    }
  }
  .available{
    color: #606368;
    font-weight: 400;
    font-size: .24rem;
    font-style: normal;
    margin-top .21rem
  }
  .status {
    position: absolute;
    right: 0.5rem;
    font-size: 0.24rem;
    font-family: PingFangSC-Regular-, PingFangSC-Regular;
    font-weight: normal;
    margin-top: 0.1rem;
    .statusYellow {
      color: #FAAD14;
      display: flex;
      align-items: center;
    }
    .statusCircleYellow {
      width: 0.12rem;
      height: 0.12rem;
      background: #FDB320;
      border-radius: 50%;
      margin-right: 0.1rem;
    }
    .statusGreen {
      color: #52C41A;
      display: flex;
      align-items: center;
    }
    .statusYellow {
      color: #FDB320;
      display: flex;
      align-items: center;
    }
    .statusCircleGreen {
      width: 0.12rem;
      height: 0.12rem;
      background: #52C41A;
      border-radius: 50%;
      margin-right: 0.1rem;
    }
    .statusRed {
      color: #F5222D;
      display: flex;
      align-items: center;
    }
    .statusCircleRed {
      width: 0.12rem;
      height: 0.12rem;
      background: #F5222D;
      border-radius: 50%;
      margin-right: 0.1rem;
    }
    .statusBlue {
      color: #3F74F6;
      display: flex;
      align-items: center;
    }
    .statusGray {
      color: #a4a6a9;
      display: flex;
      align-items: center;
    }
    .statusGreen {
      color: #10CC99;
      display: flex;
      align-items: center;
    }
    .statusCircleBlue {
      width: 0.14rem;
      height: 0.14rem;
      background: #3F74F6;
      border-radius: 50%;
      margin-right: 0.1rem;
    }
    .statusCircleGray {
      width: 0.14rem;
      height: 0.14rem;
      background: #a4a6a9;
      border-radius: 50%;
      margin-right: 0.1rem;
    }
    .statusCircleGreen {
      width: 0.14rem;
      height: 0.14rem;
      background: #10CC99;
      border-radius: 50%;
      margin-right: 0.1rem;
    }
    .statusCircleYellow {
      width: 0.12rem;
      height: 0.12rem;
      background: #FDB320;
      border-radius: 50%;
      margin-right: 0.1rem;
    }
    .statusGray {
      color: rgba(14, 20, 41, 0.4);
      display: flex;
      align-items: center;
    }
    .statusCircleGray {
      width: 0.12rem;
      height: 0.12rem;
      background: rgba(14, 20, 41, 0.4);
      border-radius: 50%;
      margin-right: 0.1rem;
    }
  }
}
.pay-bottom {
  height: 0.48rem;
  .pay-btn {
    width: 1.28rem;
    background: #fff;
    border-radius: .1rem;
    border: 1px solid rgba(14, 20, 41, 0.2);
    text-align: center;
    color: #0E1429;
    font-size: .24rem;
    box-sizing: border-box;
    padding: 0.09rem 0;
    position: absolute;
    right: 0.47rem;
  }
}

.toTest{
  width: 1.44rem;
  height: .56rem;
  border-radius: .10rem;
  background-color: #165DFF;
  color #fff;
  display flex;
  align-items center;
  justify-content center;
  font-size .26rem;
  align-self flex-end
  position absolute;
  right 0
}



.contact-dialog-content {
  display flex;
  justify-content center;
  box-sizing border-box
  align-items center
  flex-direction column
  color: #1D2129;
  padding-bottom .60rem

  .features {

    font-weight: 400;
    font-size: .32rem;
    margin-top .40rem
    display grid
    grid-template-columns repeat(2, 1fr)
    grid-gap .30rem 1rem

    .feature {
      display flex
      align-items center;
      justify-content center

      .icon {
        color #165DFF
        margin-right .16rem
      }
    }
  }

  .qr-img-wrapper {
    .qr-img {
      margin-top .39rem
      width 3rem
    }

    .qr-tip {
      color: #242424;
      font-weight: 400;
      font-size: .28rem;
      text-align center
    }

  }
}
</style>
